import React from "react";
import { Lock, TrendingUp, Clock, Users } from "lucide-react";

const cases = [
  {
    industry: "Roofing & Exteriors",
    icon: TrendingUp,
    headlineMetric: "+38%",
    headlineLabel: "booked jobs · 90 days",
    sub: "After-hours lead capture + automated follow-up routing.",
  },
  {
    industry: "Med Spa · multi-location",
    icon: Clock,
    headlineMetric: "0",
    headlineLabel: "missed calls · last 30 days",
    sub: "AI receptionist + booking automation across 3 locations.",
  },
  {
    industry: "Real Estate · team",
    icon: Users,
    headlineMetric: "127",
    headlineLabel: "qualified leads / month",
    sub: "Inbound qualification + auto-routing to the right agent.",
  },
];

export default function CaseStudies() {
  return (
    <section
      id="case-studies"
      className="relative section-padding"
      data-testid="case-studies-section"
    >
      <div className="absolute inset-0 dot-bg opacity-20 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12 lg:mb-14 reveal">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.3em] text-[#39FF14]">
              <span className="w-6 h-px bg-[#39FF14]" />
              Results
            </div>
            <h2 className="mt-4 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-[1.05]">
              Real systems.{" "}
              <span className="gradient-text-green">Real outcomes.</span>
            </h2>
          </div>
          <p className="text-sm sm:text-base text-zinc-400 max-w-md leading-relaxed">
            We're publishing full case studies once our current cohort
            completes their measurement window. Here's a preview of what's
            already in production.
          </p>
        </div>

        <div
          className="grid grid-cols-1 md:grid-cols-3 gap-5 reveal"
          data-testid="case-studies-grid"
        >
          {cases.map((c, i) => (
            <article
              key={c.industry}
              className="group relative overflow-hidden rounded-2xl border border-white/8 bg-[#0A0A0A] p-7 transition-all duration-500 hover:-translate-y-1 hover:border-[#39FF14]/30 float-card"
              data-testid={`case-study-${i + 1}`}
            >
              {/* hover sheen */}
              <div className="absolute -inset-px rounded-2xl bg-gradient-to-br from-[#39FF14]/8 via-transparent to-[#007AFF]/8 opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-md pointer-events-none" />

              <div className="relative flex items-center justify-between">
                <div className="svc-icon">
                  <c.icon className="w-5 h-5" />
                </div>
                <span className="inline-flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-widest text-zinc-500 px-2.5 py-1 rounded-full border border-white/8 bg-white/[0.02]">
                  <Lock className="w-3 h-3" strokeWidth={2} />
                  Coming Soon
                </span>
              </div>

              <div className="relative mt-6">
                <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-mono">
                  {c.industry}
                </div>
                <div className="mt-3 flex items-baseline gap-2">
                  <span
                    className="text-4xl sm:text-5xl font-bold tracking-tight text-white"
                    aria-hidden="true"
                  >
                    {c.headlineMetric}
                  </span>
                  <span className="text-xs text-zinc-500">
                    {c.headlineLabel}
                  </span>
                </div>
                <p className="mt-4 text-sm text-zinc-400 leading-relaxed">
                  {c.sub}
                </p>
              </div>

              <div className="relative mt-7 pt-5 border-t border-white/5 flex items-center justify-between text-[11px] font-mono text-zinc-500">
                <span>Full case study</span>
                <span className="text-[#39FF14]/80 group-hover:text-[#39FF14] transition">
                  Publishing soon →
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
